import {
  Edit,
  Trash2,
  Upload,
  List,
  Eye,
  EyeOff,
  RotateCcw,
  Check,
  X,
  Search,
  Plus,
  House,
  User,
  Settings,
  LogOut,
  Bell,
  Menu,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  ChevronUp,
  Download,
  FileText,
  Calendar,
  Filter,
  MoreVertical,
  MoreHorizontal,
  ArrowLeft,
  ArrowRight,
  LayoutDashboard,
  Users,
  CreditCard,
  ShieldCheck,
  LifeBuoy,
  FileCheck,
  ClipboardList,
  AlertCircle,
  Info,
  CheckCircle,
  XCircle,
  Mail,
  Phone,
  MapPin,
  Clock,
  Briefcase,
  DollarSign,
  PieChart,
  BarChart2,
  FilePlus,
  Printer,
  Share2,
  ExternalLink,
  RefreshCw,
  Lock,
  Unlock,
  UserPlus,
  UserMinus,
  Settings2,
  HelpCircle,
  Minus,
  Maximize2,
  Minimize2,
  ArrowUp,
  ArrowDown,
  TrendingUp,
  TrendingDown,
  Activity,
  History,
  HardDrive,
  Cloud,
  DownloadCloud,
  UploadCloud,
  FileMinus,
  File,
  Download as LucideDownload,
  Car,
  Heart,
  Shield,
  Wrench,
  HeartPulse,
  Files,
  FolderTree,
  Plane,
  LayoutGrid,
  AlertTriangle,
  Building2,
  ArrowLeftRight,
  Tag,
  GitBranch,
  Award,
  BookOpen,
  MessageSquare,
  FileQuestion,
  Handshake,
  Bookmark,
  HeartPlus,
  ShieldPlus,
  BookmarkCheck,
  Package,
  Key,
  Shuffle,
  Folder,
  Calculator,
  Hourglass,
  Gauge,
  Wallet,
  UserCheck,
  ToggleRight,
  ToggleLeft,
  HandCoins,
  Target
} from 'lucide-angular';

export const lucideIcons = {
  File,
  Edit,
  Trash2,
  Upload,
  List,
  Eye,
  EyeOff,
  RotateCcw,
  Check,
  X,
  Search,
  Plus,
  House,
  User,
  Settings,
  LogOut,
  Bell,
  Menu,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  ChevronUp,
  Download,
  FileText,
  Calendar,
  Filter,
  MoreVertical,
  MoreHorizontal,
  ArrowLeft,
  ArrowRight,
  LayoutDashboard,
  Users,
  CreditCard,
  ShieldCheck,
  LifeBuoy,
  FileCheck,
  ClipboardList,
  AlertCircle,
  Info,
  CheckCircle,
  XCircle,
  Mail,
  Phone,
  MapPin,
  Clock,
  Briefcase,
  DollarSign,
  PieChart,
  BarChart2,
  FilePlus,
  Printer,
  Share2,
  ExternalLink,
  RefreshCw,
  Lock,
  Unlock,
  UserPlus,
  UserMinus,
  Settings2,
  HelpCircle,
  Minus,
  Maximize2,
  Minimize2,
  ArrowUp,
  ArrowDown,
  TrendingUp,
  TrendingDown,
  Activity,
  History,
  HardDrive,
  Cloud,
  DownloadCloud,
  UploadCloud,
  FileMinus,
  LucideDownload,
  Car,
  Heart,
  Shield,
  Wrench,
  HeartPulse,
  Files,
  FolderTree,
  Plane,
  LayoutGrid,
  AlertTriangle,
  Building2,
  ArrowLeftRight,
  Tag,
  GitBranch,
  Award,
  BookOpen,
  MessageSquare,
  FileQuestion,
  Handshake,
  Bookmark,
  HeartPlus,
  ShieldPlus,
  BookmarkCheck,
  Package,
  Key,
  Shuffle,
  Folder,
  Calculator,
  Hourglass,
  Gauge,
  Wallet,
  UserCheck,
  ToggleRight,
  ToggleLeft,
  HandCoins,
  Target
};
